module.exports = __webpack_public_path__ + "static/media/newNeritoLogoBig.3bacfe8e.svg";